import { Button, NumberTextField } from '@montugroup/design-system';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import { ButtonGroup } from '@mui/material';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

interface NumericStepperInputProps {
  value: number;
  onChange: (value: number) => void;
  disabled: boolean;
  min?: number;
  max?: number;
  step?: number;
}

const NumericStepperInput: FC<NumericStepperInputProps> = ({
  value,
  onChange,
  disabled,
  min = 0,
  max = 100,
  step = 1,
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    onChange(inputValue);
  }, [inputValue, onChange]);

  const handleDecrement = () => {
    if (inputValue - step >= min && !disabled) {
      setInputValue(inputValue - step);
    }
  };

  const handleIncrement = () => {
    if (!disabled && inputValue + step <= max) {
      setInputValue(inputValue + step);
    }
  };

  const handleInputChange = (v: { value: string }) => {
    const raw = v.value;
    const newValue = raw === '' ? NaN : Number(raw);
    if (!isNaN(newValue) && newValue >= min && newValue <= max && !disabled) {
      setInputValue(newValue);
    }
  };

  return (
    <ButtonGroup size="small" style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        variant="text"
        sx={{
          minWidth: 0,
        }}
        onClick={handleDecrement}
        disabled={disabled || inputValue <= min}
      >
        <Remove fontSize="small" />
      </Button>
      <NumberTextField
        value={inputValue}
        disabled={disabled}
        size="small"
        sx={{ px: 1 }}
        inputProps={{
          style: { textAlign: 'center', width: '3em', padding: '2px', fontSize: '14px' },
        }}
        onValueChange={handleInputChange}
        allowNegative={false}
      />
      <Button
        variant="text"
        sx={{
          minWidth: 0,
        }}
        onClick={handleIncrement}
        disabled={disabled || inputValue >= max}
      >
        <Add fontSize="small" />
      </Button>
    </ButtonGroup>
  );
};

export default NumericStepperInput;
